"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const m = require("mithril");
function makeMenuItem(title, callback) {
    const top = m('li', { onclick: callback }, title);
    return top;
}
exports.makeMenuItem = makeMenuItem;
/**
 *
 * @param el html element
 * @param className class attribute
 * @returns class name is contained after swap
 */
function toggleElement(el, className) {
    const contained = el.classList.contains(className);
    if (el.classList.contains(className))
        el.classList.remove(className);
    else
        el.classList.add(className);
    return !contained;
}
var indexToggle = 0;
var indexToggleMissed = 0;
var lastElementForShow = null;
function toggleShowDropdown() {
    if (this === null)
        alert("toggleShowDropdown has this === null");
    // alert(`toggleShowDropdown: this: ${this}, lastElementForShow: ${lastElementForShow} `)
    const selector = ".dropdown";
    const all = document.querySelectorAll(selector);
    indexToggle++;
    all.forEach(el => {
        el.classList.remove('show');
    });
    if (lastElementForShow != this) {
        this.classList.add('show');
        lastElementForShow = this;
    }
    else {
        lastElementForShow = null;
    }
    // alert(`${indexToggle}, ${indexToggleMissed}, ${this.nodeName} call toggleShow element found: ${all.length}`)
}
function makeMenu(menuTitle, titles, callbackFactory) {
    const children = titles.map(title => makeMenuItem(title, callbackFactory(title)));
    const dropdownItems = m('ul', { class: "drop-nav" }, children);
    const top = m('li', { class: "dropdown", onclick: toggleShowDropdown }, [menuTitle, dropdownItems,]);
    return top;
}
exports.makeMenu = makeMenu;
function makeLi(title, message) {
    const res = m('li', { onclick: () => { alert(message ? message : title); toggleShowDropdown(); } }, title);
    return res;
}
//<span class="logo" href="#"></span>
function makeLogo() {
    const res = m('span', { class: "logo", href: "#" });
    return res;
}
function makeHeaderWithMenu(menuTitle, titles, callbackFactory) {
    const menu = makeMenu(menuTitle, titles, callbackFactory);
    return menu;
}
exports.makeHeaderWithMenu = makeHeaderWithMenu;
function makeMenuBar(menus) {
    const home = makeLi("Home");
    const about = makeLi("About", "ShapeLogic TypeScript\nTesting menu system");
    const logo = makeLogo();
    const all = menus.concat([about]);
    const fullMenu = m('ul', { class: "main-nav" }, all);
    const topWithMenu = m('header', { class: "main-header" }, [logo, fullMenu]);
    const top = m('div', [fullMenu]);
    return top;
}
function callbackFactoryAlert(title) {
    return () => alert(title);
}
function makeHeaderWithMenuTest(callbackFactory = callbackFactoryAlert) {
    const colorSwap = [
        'rgba',
        'rbga',
        'gbra',
        'bgra',
        'rrra',
        'ggga',
        'bbba'
    ];
    const imageOperations = [
        'inverse',
        'edge',
        'threshold'
    ];
    const swap = makeHeaderWithMenu("Swap", colorSwap, callbackFactory);
    const other = makeHeaderWithMenu("Operations", imageOperations, callbackFactory);
    const res = makeMenuBar([swap, other]);
    // console.log(JSON.stringify(res))
    return res;
}
exports.makeHeaderWithMenuTest = makeHeaderWithMenuTest;



//////////////////
// WEBPACK FOOTER
// ./gui/mithril-menu.ts
// module id = 13
// module chunks = 0